<div class="bottom-sheet-inner df-guest-sheet">
  <div class="df-guest-sticky">
    <div class="bottom-sheet-handle"></div>
    <div class="df-guest-head d-flex ion-align-items-start">
      <div class="flex-1">
        <div class="df-guest-title font800 dutyfree-text-color">
          {{ 'dutyfree.checkout.guest_picker_title' | translate }}
        </div>
        <div class="dutyfree-text-secondary fs-2 mart4">
          {{ 'dutyfree.checkout.guest_picker_sub' | translate }}
        </div>
      </div>
      <button
        type="button"
        class="df-guest-x df-plain d-flex ion-align-items-center ion-justify-content-center cursor-pointer"
        (click)="close()"
        [attr.aria-label]="'modals.generic_alert.close' | translate"
      >
        <ion-icon name="close-outline" class="font20"></ion-icon>
      </button>
    </div>

    <div class="df-guest-search d-flex ion-align-items-center card-white-background-color padl10 padr10">
      <ion-icon name="search-outline" class="font18 dutyfree-text-muted"></ion-icon>
      <input
        type="search"
        class="df-guest-search-input flex-1 fs-3 dutyfree-text-color ion-no-padding"
        [placeholder]="'dutyfree.checkout.guest_picker_search' | translate"
        [value]="searchQuery"
        (input)="searchQuery = $any($event.target).value"
        autocomplete="off"
      />
      <button
        type="button"
        class="df-plain df-guest-search-clear d-flex ion-align-items-center ion-justify-content-center cursor-pointer ion-no-padding"
        *ngIf="searchQuery"
        (click)="clearSearch()"
        [attr.aria-label]="'dutyfree.checkout.guest_picker_clear' | translate"
      >
        <ion-icon name="close-circle-outline" class="font18 dutyfree-text-secondary"></ion-icon>
      </button>
    </div>
  </div>

  <div class="df-guest-scroll ion-content-scroll-host">
    <div
      class="df-guest-empty d-flex flex-col ion-align-items-center ion-justify-content-center ion-text-center"
      *ngIf="!filteredGuests.length"
    >
      <div class="df-guest-empty-icon d-flex ion-align-items-center ion-justify-content-center">
        <ion-icon name="people-outline" class="font28"></ion-icon>
      </div>
      <div class="fs-4 font700 dutyfree-text-color mart10">
        {{
          (searchQuery
            ? 'dutyfree.checkout.guest_picker_no_match'
            : 'dutyfree.checkout.guest_picker_empty'
          ) | translate
        }}
      </div>
    </div>

    <button
      type="button"
      class="df-guest-card df-plain d-flex ion-align-items-center w100 ion-text-start cursor-pointer"
      *ngFor="let guest of filteredGuests"
      (click)="selectGuest(guest)"
    >
      <span class="df-guest-avatar fs-3 font800 d-flex ion-align-items-center ion-justify-content-center">
        {{ guestInitials(guest) }}
      </span>
      <span class="df-guest-copy flex-1">
        <span class="fs-4 font700 dutyfree-text-color d-block">{{ guestName(guest) }}</span>
        <span class="fs-2 dutyfree-text-secondary d-block mart4" *ngIf="guestPhone(guest)">
          {{ guestPhone(guest) }}
        </span>
        <span class="fs-2 dutyfree-text-secondary d-block mart4" *ngIf="guestEmail(guest)">
          {{ guestEmail(guest) }}
        </span>
      </span>
      <ion-icon name="chevron-forward-outline" class="df-guest-chev font18 dutyfree-text-muted"></ion-icon>
    </button>
  </div>
</div>
